/* src/components/library-item-filters/library-item-filters.component.scss */
app-library-item-filters {
  display: block;
}
.library-item-filters__title {
  --vwui-size-spacing-xs: 0;
  --vwui-size-spacing-xxs: 0;
  margin-bottom: var(--vwui-size-spacing-base);
}
.library-item-filters__box {
  background: var(--vwui-color-light);
  box-shadow: var(--vwui-shadow-large);
}
.library-item-filters__columns {
  display: grid;
  grid-gap: var(--vwui-size-spacing-lg);
  grid-template-columns: 16.5rem 1fr 1fr;
}
.filter-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 100%;
}
.filter-input__group {
  --vwui-input-group--spacing-label: 0;
  --vwui-input-group--spacing-input: 0;
}
.filter-input__group--sublabel label {
  display: flex;
  align-items: center;
  gap: var(--vwui-size-spacing-base);
}
.filter-input__number {
  width: 6rem;
}
.filter-input__number--price {
  width: 9rem;
}
.filter-input__label {
  width: 30%;
  font-weight: var(--vwui-font-weight-semibold);
}
.filter-input + .filter-input {
  margin-top: var(--vwui--spacing--sm);
}
/*# sourceMappingURL=library-item-filters.component-HMTI4LFU.css.map */
